/** The CSRF token to send back as X-CSRFToken.
 *
 * Django's `csrftoken` is not safe to read from a consumer page: seekr also
 * serves the consumer apex, so its own host-only cookie of that name sits on
 * the page next to the edge's domain-scoped one, and document.cookie exposes no
 * way to tell which one the edge will be sent. The edge mirrors its own under a
 * name nothing else writes (src/proxy/cookies.ts — both names are duplicated
 * there).
 *
 * The mirror only exists where the edge widened the cookie's Domain. Without
 * that widening its csrftoken is shared with no other host, so the plain name
 * is already unambiguous — which is the fallback, not a legacy path.
 */

import { getCookie } from "./cookies";

const CSRF_COOKIE = "csrftoken";
const CSRF_MIRROR_COOKIE = "id_csrftoken";

function csrfToken(): string {
  return getCookie(CSRF_MIRROR_COOKIE) || getCookie(CSRF_COOKIE);
}

export { csrfToken, CSRF_MIRROR_COOKIE };
